export default __webpack_public_path__ + "static/media/instagram.0dd482fa.svg";